import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { TimeActivitiesModel } from '~/models';
import { selectors } from '~/store/state-selectors';
export const useQboTimeActivities = function useQboTimeActivities(relationshipId) {
    let { refreshOnHookMount = false, enabled = true } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const allowTimeActivities = useStore(selectors.integration.allowTimeActivities);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.QboTimeActivities,
            relationshipId
        ],
        queryFn: ()=>allowTimeActivities ? api.qbo.getTimeActivities(relationshipId) : Promise.resolve(new TimeActivitiesModel()),
        enabled,
        refreshOnHookMount
    });
    return {
        data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
